import Vue from "vue";
import VueMeta from "vue-meta";
import App from "./App.vue";
import "./registerServiceWorker";
import "materialize-css/dist/css/materialize.min.css";
import "material-design-icons/iconfont/material-icons.css";
import router from "./router";
import { globalFunctions } from "./common.js";

Vue.use(VueMeta);

Vue.config.productionTip = false;

// Define global functions wiht mixin
Vue.mixin({
  methods: globalFunctions
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
